import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { InputRow } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { List as MovableList } from 'react-movable';
import { SpecialSportsFilterItem } from './SpecialSportsFilterItem';
import { AddCompetition } from './AddCompetition';
import { ButtonOnInputSide } from 'src/domains/layouts/shared/buttons/Button.style';
import { FiltersListWrapper, SportsFiltersWrapper, FiltersWrapper, MovableItemWrapper } from '../../Sports/SportsForm/SportsFilters/SportsFilters.style';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';

export const SpecialSportsFilters = observer(() => {
    const { cmsState } = useAppStateContext();
    const {
        handleAddFilter,
        handleFiltersOrder,
        filtersList,
        activeFilter,
        filterNameStatus, filterName, filterNameModel
    } = cmsState.specialSportsState;


    return (
        <div>
            <InputRow>
                <OldInput
                    label='Filter name'
                    status={filterNameStatus}
                    formInputState={filterName}
                    model={filterNameModel}
                />
                <ButtonOnInputSide version='primary' size='regular' onClick={handleAddFilter}>Add filter</ButtonOnInputSide>
            </InputRow>
            {filtersList.length > 0 ? (
                <SportsFiltersWrapper>
                    <FiltersListWrapper>
                        <Label>Filters and added competitions</Label>
                        <MovableList
                            values={filtersList}
                            onChange={handleFiltersOrder}
                            renderList={({ children, props }): React.ReactNode => <FiltersWrapper {...props}>{children}</FiltersWrapper>}
                            renderItem={({ value, props, isDragged }): JSX.Element | null => {
                                return (
                                    <MovableItemWrapper {...props}>
                                        <SpecialSportsFilterItem key={value.slug} slug={value.slug} isDragged={isDragged} />
                                    </MovableItemWrapper>
                                );
                            }}
                        />
                    </FiltersListWrapper>

                    {activeFilter !== null ? (
                        <AddCompetition />
                    ) : null}

                </SportsFiltersWrapper>
            ) : null}
        </div>
    );
});
